import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { environment } from "../../../../../../environments/environment";
import { ApiEnum } from "../../../../../shared/enums/api.enum";
import { HeaderBasicAuthorizationService } from "../../../../../shared/services/header-basic-authorization.service";

@Injectable({
	providedIn: "root",
})
export class PersonalActivoService {
	constructor(private http: HttpClient, private headerBasicAuthorization: HeaderBasicAuthorizationService) {}

	public getPersonalActivo() {
		return this.http.get(`${environment.api.WS_HCM.url}/PersonalActivo/GetPersonalActivo`, { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) }).pipe(map((data) => data));
	}

	public guardar(Usuario: any, Nombres: any, DocIdentidad: any, IsActivo: any, Sociedad: any, ApellidoPaterno: any, ApellidoMaterno: any, Turno: any, Sede: any,
		FechaInicioContrato, FechaFinContrato, PlazoContratacion, Genero, EstadoCivil, HijosMenores, EdadHijo, NivelEstudios, FechaNacimiento, Direccion, Ciudad, Telefono,
        NombreContactoEmergencia, NroContactoEmergencia, Correo, Cargo, SistemaPensiones, Banco, NroCuentaBancaria, NroCuentaInterbancaria
	) {
		return this.http.post(`${environment.api.WS_HCM.url}/PersonalActivo/SaveUpdatePersonalActivo`, { Usuario: Usuario, Nombres: Nombres, DocIdentidad: DocIdentidad, IsActivo: IsActivo, Sociedad: Sociedad, ApellidoPaterno: ApellidoPaterno, ApellidoMaterno: ApellidoMaterno, Turno: Turno, Sede: Sede,
			FechaInicioContrato: FechaInicioContrato, FechaFinContrato: FechaFinContrato, PlazoContratacion: PlazoContratacion, Genero: Genero, EstadoCivil: EstadoCivil, HijosMenores: HijosMenores, EdadHijo: EdadHijo, NivelEstudios: NivelEstudios, FechaNacimiento: FechaNacimiento, Direccion: Direccion, Ciudad: Ciudad, Telefono: Telefono,
        	NombreContactoEmergencia: NombreContactoEmergencia, NroContactoEmergencia: NroContactoEmergencia, Correo: Correo, Cargo: Cargo, SistemaPensiones: SistemaPensiones, Banco: Banco, NroCuentaBancaria: NroCuentaBancaria, NroCuentaInterbancaria: NroCuentaInterbancaria
		 }, { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) }).pipe(map((data) => data));
	}

	public deletePersonalActivo(DocIdentidad: any) {
		return this.http.post(`${environment.api.WS_HCM.url}/PersonalActivo/DeletePersonalActivo`, { DocIdentidad: DocIdentidad }, { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) }).pipe(map((data) => data));
	}

	public exportDataExcel(objUsuario: any) {
		return this.http.post(`${environment.api.WS_HCM.url}/PersonalActivo/ValidarCargaMasivaPersonalActivo`, { objUsuario: objUsuario }, { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) }).pipe(map((response) => response));
	}

	public SaveUpdateMasivoPersonalActivo(objUsuario: any) {
		return this.http.post(`${environment.api.WS_HCM.url}/PersonalActivo/SaveUpdateMasivoPersonalActivo`, { objUsuario: objUsuario }, { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) }).pipe(map((response) => response));
	}

	public listarSociedad() {
		return this.http.get(`${environment.api.WS_HCM.url}/PersonalActivo/GetSociedad`, { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) }).pipe(map((data) => data));
	}

	public listarTurno() {
		return this.http.get(`${environment.api.WS_HCM.url}/PersonalActivo/GetTurno`, { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) }).pipe(map((data) => data));
	}

	public listarSede() {
		return this.http.get(`${environment.api.WS_HCM.url}/PersonalActivo/GetSede`, { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) }).pipe(map((data) => data));
	}

	public listarPlazoContratacion() {
		return this.http.get(`${environment.api.WS_HCM.url}/PersonalActivo/GetPlazoContratacion`, { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) }).pipe(map((data) => data));
	}

	public listarEstadoCivil() {
		return this.http.get(`${environment.api.WS_HCM.url}/PersonalActivo/GetEstadoCivil`, { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) }).pipe(map((data) => data));
	}

	public listarGenero() {
		return this.http.get(`${environment.api.WS_HCM.url}/PersonalActivo/GetGenero`, { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) }).pipe(map((data) => data));
	}

	public listarCiudad() {
		return this.http.get(`${environment.api.WS_HCM.url}/PersonalActivo/GetCiudad`, { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) }).pipe(map((data) => data));
	}

	public listarCargo() {
		return this.http.get(`${environment.api.WS_HCM.url}/PersonalActivo/GetCargo`, { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) }).pipe(map((data) => data));
	}

	public listarSistemaPensiones() {
		return this.http.get(`${environment.api.WS_HCM.url}/PersonalActivo/GetSistemaPensiones`, { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) }).pipe(map((data) => data));
	}

	public listarBanco() {
		return this.http.get(`${environment.api.WS_HCM.url}/PersonalActivo/GetBanco`, { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) }).pipe(map((data) => data));
	}
}